export default "__VITE_ASSET__CmpWkJwx__"